module.exports = __webpack_public_path__ + "static/media/t13.23d59293.png";